import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorOrderDetailResponse {
  /**
   * Indicates if purchase warnings were ignored.
   */
  @observable
  forceUsed!: boolean;

  /**
   * Distributor name.
   */
  @observable
  distributorName!: string;

  /**
   * Salespoint name.
   */
  @observable
  salespointName!: string;

  /**
   * Consortium member name.
   */
  @observable
  consortiumMemberName!: string;

  /**
   * Salespoint address.
   */
  @observable
  salespointAddress?: string;
}
